import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Typography, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useSaleCalendar } from '../SaleCalendarContext';
import DateRangeIcon from '@mui/icons-material/DateRange';
export default function CustomDatePicker() {
  const { date, onDateSelect } = useSaleCalendar();
  const [open, setOpen] = useState(false); // kontrolujemy otwieranie

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Typography
        variant="h6"
        onClick={() => setOpen(true)}
        sx={{ cursor: 'pointer' }}
      >
        <DateRangeIcon fontSize="medium" />
      </Typography>

      <DatePicker
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={date}
        onChange={newValue => onDateSelect(newValue)}
        renderInput={params => (
          <TextField
            {...params}
            sx={{
              width: 0,
              height: 0,
              padding: 0,
              margin: 0,
              visibility: 'hidden',
              position: 'absolute'
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
}
